import React, {useState,useEffect,useRef, useMemo}  from "react";
import { Menu, Dropdown, Avatar } from "antd";

import { connect } from 'react-redux'
import { 
  EditOutlined, 
  SettingOutlined, 
  ShopOutlined, 
  QuestionCircleOutlined, 
  LogoutOutlined 
} from '@ant-design/icons';
import Icon from 'components/util-components/Icon';
import IntlMessage from "components/util-components/IntlMessage";
import { signOut, actualizar_photo,actualizarUserData } from 'redux/actions/Auth';

import { Link } from "react-router-dom";


// const user_info =  JSON.parse(localStorage.getItem("user_info"))
import { APP_PREFIX_PATH } from 'configs/AppConfig'

import { IMG_PROFILE } from 'redux/constants/Auth'
import { useSelector, useDispatch } from "react-redux";
import profileService from "services/profileService";
// import { actualizar_photo } from "redux/actions";





export const NavProfile = ({signOut,actualizar_photo,actualizarUserData}) => {
  const userData = useSelector(state => state.auth.userData)
  const dispatch = useDispatch();
  const isMounted = useRef(true); // Variable de referencia para verificar si el componente está montado
  const imageRef = useRef(null);


  const [photoUsuario, setphotoUsuario] = useState(userData.photoURL); 
  const [dataPerfil, setdataPerfil] = useState(userData); 
  const [imgurl, setimgurl] = useState('hola'); 

  const [user_info] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("user_info");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });


  const menuItem = [
    {
      title: <IntlMessage id='users.editProfile' /> ,
      icon: EditOutlined ,
      path: APP_PREFIX_PATH+"/perfil/"+user_info.id+"/edit"
      },
      
      {
      title: <IntlMessage id='users.changePassword' /> ,
      icon: SettingOutlined,
      path: `${APP_PREFIX_PATH}/perfil/${user_info.id}/edit/change-password`
      },
    //   {
    //   title:  <IntlMessage id='general.manual' /> ,
    //   icon: QuestionCircleOutlined,
    //   path: "/"
    // }
  ]

  // Función para convertir la imagen en Blob
  const loadImageAsBlob = async (imageUrl) => {
      try {
        if(imageUrl){
          await fetch(imageUrl).then(async (response)=>{
            if(response.status == 403){
              let newurl = await profileService.volverFirmar();
              loadImageAsBlob(newurl.newImageSign);
                dispatch(actualizar_photo(newurl.newImageSign));
                const user_info = JSON.parse(localStorage.getItem("user_info"));
                user_info.data.photoURL = newurl.newImageSign
                localStorage.setItem("user_info", JSON.stringify(user_info));
                dispatch(actualizarUserData(user_info.data));
            }
            else{
              const blob = await response.blob();
              setphotoUsuario(URL.createObjectURL(blob))
            }
          }).catch(function (error) {
            console.log("Hubo un problema con la petición Fetch:" + error);
          });
          
        }
       
      } catch (error) {
        
        console.error('Error al cargar la imagen como Blob:', error);
      }
  };



  useEffect(()=>{
    //Llama a la función para cargar la imagen como Blob
    if(userData.photoURL !== "" && userData.photoURL !== null && userData.photoURL !== undefined){
      loadImageAsBlob(userData.photoURL);
    }
    
    setdataPerfil(userData)
  },[userData])

  

  const imagenCompo = useMemo(()=>{
    return (
    <img ref={imageRef} className="perfil-icon" src={  photoUsuario || '/img/profileUser.png'} width={50} height={50} alt="" />
    )
    
},[photoUsuario])


  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">          
          <div className="pl-2">
            <h4 className="mb-0"><Link to={`${APP_PREFIX_PATH}/perfil/${userData.id}/`}>{userData.nombre}</Link> </h4>
            <p style={{lineBreak: "anywhere"}} className="text-muted">{dataPerfil.permissions.name_rol}</p>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item key={i}>
                <Link to={ el.title==="Editar Perfil" ? APP_PREFIX_PATH+"/perfil/"+userData.id+"/edit" : el.path } >
                  <Icon className="mr-3" type={el.icon} />
                  <span  className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            ); 
          })}
          <Menu.Item key={menuItem.length + 1} onClick={e => signOut()}>
            <span>
              <LogoutOutlined className="mr-3"/>
              <span className="font-weight-normal"> <IntlMessage id='users.logout' /> </span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <div>
          {/* <img alt="alt"  src={`https://api.facturasiempre.com//api/pruebas/setcookie`} style={{'width':'5px', 'visibility':'hidden'}}/> */}
          {/* <Avatar src={!photoUsuario || photoUsuario == " " ?  '/img/profileUser.png' : photoUsuario}  icon={<UserOutlined />} /> */}
          {imagenCompo}
          </div>
        </Menu.Item>
      </Menu>
    </Dropdown>

  );
}

export default connect(null, {signOut,actualizar_photo,actualizarUserData})(NavProfile)
